import script from "./FormValidationTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormValidationTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./FormValidationTooltip.vue?vue&type=style&index=0&id=e759dc9a&lang=css"

const __exports__ = script;

export default __exports__